import React, { PureComponent } from 'react'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { compose, links, getProjectName, constants } from 'helpers'
import toggleOpen from 'local_modules/toggleOpen'

import Collapsible from 'components/ui/Collapsible/Collapsible'

import ToggleList from '../ToggleList/ToggleList'

import s from './InfoMenu.scss'


class InfoMenu extends PureComponent {

  componentWillUnmount() {
    this.removeListener()
  }

  handleOpen = () => {
    const { toggleOpen } = this.props

    this.addListener()
    toggleOpen()
  }

  handleClose = () => {
    const { toggleClose } = this.props

    toggleClose()
    this.removeListener()
  }

  addListener = () => {
    document.addEventListener('click', this.handleClose)
  }

  removeListener = () => {
    document.removeEventListener('click', this.handleClose)
  }

  openFeedbackModal = () => {
    actions.me.openFeedbackModal()
  }

  render() {
    const { isToggleActive, isMarketplace } = this.props

    return (
      <div className={s.wrapper}>
        <div className={s.container} onClick={isToggleActive ? this.handleClose : this.handleOpen}>
          <span>
            <div className={s.icon}/>
            <div className={s.iconHover}/>
          </span>
        </div>
        <Collapsible className={s.toggleListContainer} collapsed={!isToggleActive}>
          <ToggleList
            className={s.toggleList}
            links={isMarketplace ? [
              {
                title: 'Условия использования',
                to: links.marketplace.privacy,
              },
              {
                title: 'Условия участия и персональные данные',
                toOLD: constants.smartSarov.terms,
              },
              {
                title: 'Техподдержка',
                onClick: this.openFeedbackModal,
              },
            ] : [
              {
                title: 'Условия участия и персональные данные',
                toOLD: constants.smartSarov.terms,
              },
              {
                title: 'Техподдержка',
                onClick: this.openFeedbackModal,
              },
            ]}
          />
        </Collapsible>
      </div>
    )
  }
}


export default compose(
  connect({
    isMarketplace: (state) => {
      const projectName = getProjectName(state)

      return projectName === 'marketplace'
    },
  }),
  toggleOpen(),
)(InfoMenu)
